import { RightNav } from '@/shared/components/RightNav';
import { icons } from '@images';
import { useAppSelector } from '@/store/hooks';
import { selectIsLoggedIn, selectIsAuthChecked } from '@/features/auth/redux';
// [TEMPORARILY HIDDEN] ChatSidebar & HamburgerIcon hidden until chat-history sidebar is re-enabled
// import { useCallback, useState } from 'react';
// import { ChatSidebar } from '@/shared/components/ChatSidebar';
// import { HamburgerIcon } from '@/shared/components/Icons';

interface OnboardingHeaderProps {
  readonly step: number;
}

export function OnboardingHeader({ step: _step }: OnboardingHeaderProps): React.ReactNode {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const isAuthChecked = useAppSelector(selectIsAuthChecked);
  // [TEMPORARILY HIDDEN] Sidebar state & handlers hidden until chat-history sidebar is re-enabled
  // const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // const handleOpenSidebar = useCallback(() => {
  //   setIsSidebarOpen(true);
  // }, []);

  // const handleCloseSidebar = useCallback(() => {
  //   setIsSidebarOpen(false);
  // }, []);

  if (!isAuthChecked || !isLoggedIn) {
    return null;
  }

  return (
    <>
      <div className="absolute top-0 left-0 z-1000 flex w-full items-center justify-between p-5">
        <div className="flex items-center gap-7">
          {/* [TEMPORARILY HIDDEN] HamburgerIcon hidden until chat-history sidebar is re-enabled */}
          {/* <button
            type="button"
            onClick={handleOpenSidebar}
            className="ml-10 flex cursor-pointer items-center justify-center border-0 bg-transparent p-0"
            aria-label="Open chat history"
          >
            <HamburgerIcon />
          </button> */}
          <img src={icons.MmtLogoIcon} alt="MakeMyTrip" className="h-10 w-32" />
        </div>
        <RightNav />
      </div>
      {/* [TEMPORARILY HIDDEN] ChatSidebar hidden until chat-history sidebar is re-enabled */}
      {/* <ChatSidebar isOpen={isSidebarOpen} onClose={handleCloseSidebar} /> */}
    </>
  );
}
